import { collectionIndex } from '@/mocks/homeData';

export default function CollectionIndexSection() {
  const highlighted = collectionIndex.find((row) => row.highlight) ?? collectionIndex[0];
  const rest = collectionIndex.filter((row) => row.id !== highlighted.id);

  return (
    <section id="index" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-primary-600 text-xs md:text-sm font-label font-medium tracking-wide">
            <i className="ri-layout-grid-line" />
            精华索引
          </p>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-snug">
            六个分区，一张表看完全站入口
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            索引按更新频率排列。第一次来，建议从热门榜开始；想慢一点读，就往下挑精华推荐。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-[minmax(0,360px)_1fr] gap-5 md:gap-6">
          <div className="rounded-lg bg-primary-500 p-6 md:p-7 flex flex-col justify-between">
            <div>
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-label">
                <i className="ri-fire-line" />
                今日首选入口
              </span>
              <h3 className="mt-4 font-heading font-black text-background-50 text-2xl md:text-3xl">
                {highlighted.name}
              </h3>
              <p className="mt-3 text-background-100/90 text-sm leading-relaxed">{highlighted.desc}</p>
            </div>
            <div className="mt-6">
              <div className="flex items-end gap-3">
                <span className="font-heading font-bold text-background-50 text-3xl">{highlighted.count}</span>
                <span className="text-background-100/80 text-xs font-label mb-1.5">条条目已收录</span>
              </div>
              <a
                href="#top-chart"
                className="mt-5 flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                直接进入
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 overflow-hidden">
            {rest.map((row, i) => (
              <a
                key={row.id}
                href="#top-chart"
                className={`grid grid-cols-[1fr_auto] items-center gap-4 px-5 md:px-6 py-4 md:py-5 cursor-pointer transition-colors hover:bg-background-100 ${
                  i !== rest.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg">
                      {row.name}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label">
                      {row.count} 条
                    </span>
                  </div>
                  <p className="mt-1.5 text-foreground-600 text-xs md:text-sm leading-relaxed">{row.desc}</p>
                </div>
                <div className="flex flex-col items-end gap-1 shrink-0">
                  <span className="text-foreground-400 text-[11px] font-label whitespace-nowrap">
                    {row.updated}更新
                  </span>
                  <i className="ri-arrow-right-up-line text-foreground-400" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}